module.exports = __webpack_public_path__ + "img/na.8114f3f9.svg";